<app-navigation></app-navigation>

<div class="privacy-container">
  <div class="privacy-hero">
    <h1>Política de Privacidad</h1>
    <p class="last-updated">Última actualización: {{ lastUpdated }}</p>
  </div>

  <div class="privacy-content">
    <section class="privacy-section">
      <h2>1. Introducción</h2>
      <p>
        En Pezeta Solutions, nos comprometemos a proteger la privacidad y seguridad de la información personal de nuestros usuarios, clientes y visitantes del sitio web. Esta Política de Privacidad describe cómo recopilamos, usamos, compartimos y protegemos su información personal.
      </p>
      <p>
        Al utilizar nuestros servicios o visitar nuestro sitio web, usted acepta las prácticas descritas en esta política.
      </p>
    </section>

    <section class="privacy-section">
      <h2>2. Información que Recopilamos</h2>
      <h3>2.1 Información Proporcionada Directamente</h3>
      <p>Podemos recopilar información que usted nos proporciona directamente, incluyendo:</p>
      <ul>
        <li>Nombre completo</li>
        <li>Correo electrónico</li>
        <li>Número de teléfono</li>
        <li>Nombre de la empresa</li>
        <li>Cargo o posición</li>
        <li>Información de contacto adicional</li>
        <li>Información proporcionada en formularios de contacto o solicitudes de servicio</li>
      </ul>

      <h3>2.2 Información Recopilada Automáticamente</h3>
      <p>Cuando visita nuestro sitio web, podemos recopilar automáticamente:</p>
      <ul>
        <li>Dirección IP</li>
        <li>Tipo de navegador y versión</li>
        <li>Sistema operativo</li>
        <li>Páginas visitadas y tiempo de navegación</li>
        <li>Referencia de origen (sitio desde el que llegó)</li>
        <li>Datos de cookies y tecnologías similares</li>
      </ul>

      <h3>2.3 Información de Servicios de Terceros</h3>
      <p>Si interactúa con nosotros a través de plataformas como WhatsApp u otros canales, podemos recopilar información proporcionada por estos servicios de acuerdo con sus políticas de privacidad.</p>
    </section>

    <section class="privacy-section">
      <h2>3. Uso de la Información</h2>
      <p>Utilizamos la información recopilada para los siguientes propósitos:</p>
      <ul>
        <li><strong>Proveer y mejorar nuestros servicios:</strong> Procesar solicitudes, responder consultas y proporcionar soporte técnico.</li>
        <li><strong>Comunicación:</strong> Enviar actualizaciones, newsletters, información de productos y servicios que puedan ser de su interés.</li>
        <li><strong>Análisis y mejora:</strong> Analizar el uso del sitio web para mejorar la experiencia del usuario y optimizar nuestros servicios.</li>
        <li><strong>Marketing:</strong> Realizar campañas de marketing y publicidad dirigidas, siempre con su consentimiento previo cuando sea requerido.</li>
        <li><strong>Cumplimiento legal:</strong> Cumplir con obligaciones legales y regulatorias aplicables.</li>
        <li><strong>Seguridad:</strong> Proteger la seguridad e integridad de nuestros sistemas y usuarios.</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>4. Compartir Información</h2>
      <p>No vendemos ni alquilamos su información personal a terceros. Podemos compartir su información en las siguientes circunstancias:</p>
      <ul>
        <li><strong>Proveedores de servicios:</strong> Compartimos información con proveedores que nos ayudan a operar nuestro negocio (hosting, análisis, email marketing, etc.).</li>
        <li><strong>Cumplimiento legal:</strong> Cuando sea requerido por ley o para proteger nuestros derechos legales.</li>
        <li><strong>Transferencias de negocio:</strong> En caso de fusión, adquisición o venta de activos, su información puede ser transferida.</li>
        <li><strong>Con su consentimiento:</strong> Compartimos información cuando usted nos autoriza explícitamente a hacerlo.</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>5. Cookies y Tecnologías Similares</h2>
      <p>
        Utilizamos cookies y tecnologías similares para mejorar la funcionalidad del sitio web, analizar el tráfico y personalizar el contenido.
      </p>
      <p>Las cookies que utilizamos incluyen:</p>
      <ul>
        <li><strong>Cookies esenciales:</strong> Necesarias para el funcionamiento básico del sitio.</li>
        <li><strong>Cookies de rendimiento:</strong> Nos ayudan a entender cómo los visitantes interactúan con nuestro sitio web.</li>
        <li><strong>Cookies de funcionalidad:</strong> Permiten recordar sus preferencias y configuraciones.</li>
        <li><strong>Cookies de análisis:</strong> Utilizadas para medir el tráfico y el comportamiento de los visitantes en el sitio mediante Google Analytics.</li>
      </ul>
      <p>
        Puede configurar su navegador para rechazar todas las cookies o para que le avise cuando se envía una cookie. Sin embargo, algunas funciones del sitio pueden no funcionar correctamente sin cookies.
      </p>
    </section>

    <section class="privacy-section">
      <h2>6. Seguridad de la Información</h2>
      <p>
        Implementamos medidas de seguridad técnicas, administrativas y físicas razonables para proteger su información personal contra acceso no autorizado, alteración, divulgación o destrucción.
      </p>
      <p>Estas medidas incluyen:</p>
      <ul>
        <li>Cifrado SSL/TLS para la transmisión de datos sensibles</li>
        <li>Autenticación de múltiples factores para acceso a sistemas críticos</li>
        <li>Auditorías de seguridad regulares</li>
        <li>Acceso restringido a información personal solo para empleados autorizados</li>
        <li>Almacenamiento seguro en servidores protegidos</li>
      </ul>
      <p>
        Sin embargo, ningún método de transmisión por Internet o almacenamiento electrónico es 100% seguro, y no podemos garantizar seguridad absoluta.
      </p>
    </section>

    <section class="privacy-section">
      <h2>7. Retención de Datos</h2>
      <p>
        Conservamos su información personal solo durante el tiempo necesario para cumplir con los propósitos descritos en esta política, a menos que la ley requiera o permita un período de retención más largo.
      </p>
      <p>Los criterios para determinar el período de retención incluyen:</p>
      <ul>
        <li>La duración de nuestra relación comercial con usted</li>
        <li>Requisitos legales, fiscales o reglamentarios</li>
        <li>Necesidades de auditoría y cumplimiento</li>
        <li>Defensa de reclamaciones legales</li>
      </ul>
    </section>

    <section class="privacy-section">
      <h2>8. Sus Derechos</h2>
      <p>De acuerdo con las leyes de protección de datos aplicables en México, usted tiene los siguientes derechos:</p>
      <ul>
        <li><strong>Acceso:</strong> Solicitar una copia de la información personal que tenemos sobre usted.</li>
        <li><strong>Rectificación:</strong> Solicitar la corrección de información inexacta o incompleta.</li>
        <li><strong>Cancelación:</strong> Solicitar la eliminación de su información personal.</li>
        <li><strong>Oposición:</strong> Oponerse al procesamiento de su información personal para ciertos propósitos.</li>
        <li><strong>Revocación del consentimiento:</strong> Retirar su consentimiento para el procesamiento de datos en cualquier momento.</li>
        <li><strong>Limitación del tratamiento:</strong> Solicitar la restricción del procesamiento de sus datos en ciertas circunstancias.</li>
      </ul>
      <p>
        Para ejercer estos derechos, puede contactarnos en: <a href="mailto:contacto@pezetasolutions.com">contacto&#64;pezetasolutions.com</a>
      </p>
    </section>

    <section class="privacy-section">
      <h2>9. Privacidad de Menores</h2>
      <p>
        Nuestros servicios no están dirigidos a menores de 18 años. No recopilamos intencionalmente información personal de menores. Si descubrimos que hemos recopilado información de un menor sin el consentimiento de los padres o tutores, eliminaremos esa información de inmediato.
      </p>
    </section>

    <section class="privacy-section">
      <h2>10. Transferencias Internacionales</h2>
      <p>
        Su información puede ser transferida y almacenada en servidores ubicados fuera de México. En tales casos, garantizamos que se implementen las medidas de protección adecuadas de acuerdo con las leyes aplicables.
      </p>
      <p>
        Los servicios de terceros que utilizamos (como Azure, Google Analytics, Meta) pueden procesar datos en otros países, siempre cumpliendo con estándares internacionales de protección de datos.
      </p>
    </section>

    <section class="privacy-section">
      <h2>11. Enlaces a Sitios de Terceros</h2>
      <p>
        Nuestro sitio web puede contener enlaces a sitios web de terceros. No somos responsables de las prácticas de privacidad de estos sitios. Le recomendamos revisar las políticas de privacidad de cualquier sitio web de terceros que visite.
      </p>
    </section>

    <section class="privacy-section">
      <h2>12. Integración con Meta Platforms (WhatsApp Business API)</h2>
      <p>
        Pezeta Solutions opera la plataforma Chatbot Pezeta integrándola con WhatsApp Business API a través de la infraestructura de Meta Platforms. Desarrollamos y operamos la plataforma en nombre de nuestros clientes empresariales (en adelante, "Tenants"), quienes a su vez interactúan con sus propios usuarios finales a través de dicha plataforma. Cada Tenant utiliza su propia cuenta de WhatsApp Business Account (WABA) verificada por Meta.
      </p>

      <h3>12.1 Datos Recibidos desde WhatsApp</h3>
      <p>A través de los webhooks de Meta, podemos recibir y procesar los siguientes datos de los usuarios finales de nuestros clientes:</p>
      <ul>
        <li>Número de teléfono de WhatsApp y nombre de perfil público</li>
        <li>ID de usuario de WhatsApp Business Account (WABA ID)</li>
        <li>Contenido de los mensajes enviados (texto, imágenes, documentos, audio, video, stickers, ubicaciones y otros tipos de medios admitidos por la API)</li>
        <li>Metadatos del mensaje (timestamp, ID de mensaje, estado de entrega y lectura)</li>
        <li>Información de la cuenta de WhatsApp Business del cliente (número de teléfono de la cuenta, nombre de la empresa)</li>
      </ul>

      <h3>12.2 Finalidad del Tratamiento</h3>
      <p>Los datos recibidos desde Meta se utilizan exclusivamente para:</p>
      <ul>
        <li>Entregar, procesar y registrar los mensajes en la plataforma del cliente correspondiente</li>
        <li>Automatizar respuestas mediante inteligencia artificial según la configuración del cliente</li>
        <li>Generar resúmenes y análisis de conversaciones para uso interno del cliente</li>
        <li>Proporcionar reportes de métricas de uso a los clientes</li>
        <li>Cumplir con las obligaciones contractuales con el cliente y con las políticas de uso de Meta</li>
      </ul>

      <h3>12.3 Almacenamiento y Retención</h3>
      <p>
        Los mensajes y datos de conversaciones recibidos desde WhatsApp se almacenan en bases de datos seguras ubicadas en servidores de Microsoft Azure con cifrado en reposo y en tránsito. Los datos de conversaciones se retienen durante el período activo del contrato del cliente más un máximo de <strong>90 días adicionales</strong> después de la terminación del contrato, salvo que el cliente solicite eliminación anticipada o que obligaciones legales requieran una retención mayor.
      </p>
      <p>
        Los archivos multimedia (imágenes, documentos, audio, video) recibidos vía WhatsApp se almacenan en Azure Blob Storage con acceso restringido y se eliminan de acuerdo con las políticas de retención del cliente o al término del contrato.
      </p>

      <h3>12.4 Cumplimiento con Políticas de Meta</h3>
      <p>
        Como operadores de una plataforma integrada con WhatsApp Business API, nos comprometemos a cumplir y hacer cumplir a nuestros clientes las siguientes políticas de Meta:
      </p>
      <ul>
        <li>
          <a href="https://www.whatsapp.com/legal/business-policy/" target="_blank" rel="noopener noreferrer">Política de WhatsApp Business</a>
        </li>
        <li>
          <a href="https://developers.facebook.com/terms/" target="_blank" rel="noopener noreferrer">Términos de la Plataforma de Desarrolladores de Meta</a>
        </li>
        <li>Política Comercial de Meta y Directrices de Mensajería</li>
        <li>Requisitos de consentimiento explícito para envío de mensajes de marketing (Opt-In obligatorio)</li>
      </ul>
      <p>
        Los clientes que utilizan nuestra plataforma son responsables de obtener el consentimiento válido de sus usuarios finales antes de enviarles mensajes a través de WhatsApp Business API, de acuerdo con las políticas de Meta y las leyes de protección de datos aplicables.
      </p>

      <h3>12.5 No Somos Meta</h3>
      <p>
        Pezeta Solutions es un proveedor de software independiente y no es Meta Platforms, Inc. ni ninguna de sus subsidiarias. Los datos almacenados en los servidores de Meta (incluyendo el historial de mensajes en la aplicación de WhatsApp) están sujetos a las políticas de privacidad de Meta y deben gestionarse directamente con Meta.
      </p>
    </section>

    <section class="privacy-section">
      <h2>13. Procesamiento con Inteligencia Artificial (OpenAI)</h2>
      <p>
        La plataforma Chatbot Pezeta utiliza modelos de lenguaje de <strong>OpenAI</strong> (incluyendo GPT-4 y modelos relacionados) para generar respuestas automáticas en las conversaciones de chatbot de nuestros clientes.
      </p>
      <h3>13.1 Qué datos se envían a OpenAI</h3>
      <p>
        Para generar respuestas contextuales, enviamos a la API de OpenAI el contenido de los mensajes relevantes de la conversación en curso (historial de conversación necesario para el contexto), junto con el prompt de configuración definido por el cliente para su chatbot. No se envían datos de identificación personal adicionales más allá del contenido del mensaje.
      </p>
      <h3>13.2 Uso de datos por OpenAI</h3>
      <p>
        Pezeta Solutions utiliza la API de OpenAI bajo los términos del plan de API empresarial, que establece que <strong>OpenAI no utiliza los datos enviados mediante la API para entrenar ni mejorar sus modelos</strong>, salvo que el cliente opte explícitamente por dicha opción. Los datos son procesados exclusivamente para generar la respuesta solicitada y no son retenidos por OpenAI más allá del tiempo necesario para el procesamiento de la solicitud. Para mayor detalle, consulte la <a href="https://openai.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer">Política de Privacidad de OpenAI</a>.
      </p>
      <h3>13.3 Controles del cliente</h3>
      <p>
        Los clientes de Chatbot Pezeta pueden configurar y limitar el comportamiento de la IA desde el panel de administración. Los clientes son responsables de asegurarse de que el uso de IA en sus conversaciones cumple con la legislación local aplicable y con los avisos de privacidad que proporcionan a sus propios usuarios finales.
      </p>
    </section>

    <section class="privacy-section">
      <h2>14. Eliminación de Datos del Usuario</h2>
      <p>
        Usted tiene derecho a solicitar la eliminación de sus datos personales en cualquier momento, de conformidad con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) y, cuando sea aplicable, con el Reglamento General de Protección de Datos (GDPR).
      </p>
      <p>
        Para conocer el proceso completo, los plazos de respuesta y las excepciones aplicables, visite nuestra página dedicada:
      </p>
      <p>
        <a routerLink="/eliminacion-de-datos"><strong>Solicitar Eliminacion de Datos</strong></a>
      </p>
      <p>
        En esa página encontrará instrucciones paso a paso para usuarios finales de nuestros chatbots y para clientes empresariales de la plataforma.
      </p>
    </section>

    <section class="privacy-section">
      <h2>16. Cambios a esta Política</h2>
      <p>
        Podemos actualizar esta Política de Privacidad ocasionalmente para reflejar cambios en nuestras prácticas o por razones legales u operativas. La fecha de la última actualización se indica al inicio de este documento.
      </p>
      <p>
        Le notificaremos sobre cambios materiales mediante un aviso destacado en nuestro sitio web o por correo electrónico. Le recomendamos revisar esta política periódicamente.
      </p>
    </section>

    <section class="privacy-section">
      <h2>17. Información de Contacto</h2>
      <p>
        Si tiene preguntas, comentarios o inquietudes sobre esta Política de Privacidad o sobre cómo manejamos su información personal, puede contactarnos:
      </p>
      <div class="contact-info">
        <p><strong>Pezeta Solutions</strong></p>
        <p>Los Mochis, Sinaloa, México</p>
        <p>Email: <a href="mailto:contacto@pezetasolutions.com">contacto&#64;pezetasolutions.com</a></p>
        <p>Teléfono: +52 668 856 6833</p>
        <p>WhatsApp: <a href="https://wa.me/message/GTV3AEMP6MFNC1" target="_blank" rel="noopener">Contactar por WhatsApp</a></p>
      </div>
    </section>

    <section class="privacy-section consent-section">
      <h2>18. Consentimiento</h2>
      <p>
        Al utilizar nuestro sitio web y servicios, usted reconoce que ha leído y comprendido esta Política de Privacidad y consiente el procesamiento de su información personal de acuerdo con los términos aquí establecidos.
      </p>
    </section>
  </div>
</div>

<app-footer></app-footer>
